import { ProjectShowContext } from 'src/entities/project'
import { useContext } from 'react'

const useProjectShow = () => useContext(ProjectShowContext)
export default useProjectShow
